module.exports = __webpack_public_path__ + "img/button-crowdfunding_narrow.63231a05.jpg";